<template>
  <div class="pecipeList">
    <div>
      <el-radio-group v-model="conditions" @change="tabConditions">
        <el-radio-button label="m">按月</el-radio-button>
        <el-radio-button label="y">按年</el-radio-button>
      </el-radio-group>
    </div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="月份区间" label-width="70px" v-if="conditions === 'm'">
        <el-date-picker
            @input="search"
            v-model="searchForm.monthTime"
            value-format="yyyy-MM-dd"
            type="monthrange"
            style="width: 220px"
            unlink-panels
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年份区间" label-width="70px" v-if="conditions === 'y'">
        <el-date-picker
            @input="search"
            v-model="searchForm.startYear"
            type="year"
            value-format="yyyy-MM-dd"
            style="width: 220px"
            placeholder="开始年份"
            unlink-panels>
        </el-date-picker>
        -
        <el-date-picker
            @input="search"
            v-model="searchForm.endYear"
            type="year"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            unlink-panels
            placeholder="结束年份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :dicType="6"></DicInput>
      </el-form-item>
      <el-form-item label="设备类型">
        <DicInput @fieldId="fieldId($event,'TypeId')" :dicType="1"></DicInput>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <!--      <el-button type="warning" style="float: right" @click="viewList">查看表格<i class="el-icon-view el-icon&#45;&#45;right"></i>-->
      <!--      </el-button>-->
    </div>
    <div ref="mis4" style="width:100%;height:650px;"></div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
// // 再引入你需要使用的图表类型，标题，提示信息等
import * as echarts from 'echarts';
import DicInput from "@/components/DicInput";
export default {
  name: "pecipeList",
  data() {
    return {
      tableData: [],
      searchForm: {
        monthTime: [],
        startYear: '2021-01-01',
        endYear: '2022-01-01',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      conditions: 'm',
    }
  },
  components: {
    Pagination,
    DicInput
  },
  methods: {
    // -------------------查询条件/清空-------------------
    search() {
      this.tabConditions()
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm = {
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        operatorId:'',
        TypeId:'',
      }
      this.init()
    },
    // viewList() {
    //   this.$router.push('/recipeStatistics/salesList')
    // },
    echarts(a,b,c) {
      this.mis4 = echarts.init(this.$refs.mis4);
      this.mis4.setOption(
          {
            legend: {
              data: b
            },
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: a
            },
            yAxis: {
              type: 'value'
            },
            series: c
          }
      )
    },
    tabConditions() {
      let url = ''
      let data = {}
      url = '/Statistic/PFStatistic/GetDeviceSale'
      let start, end
      if (this.conditions === 'm') {
        start = this.searchForm.monthTime[0]
        end = this.searchForm.monthTime[1]
      } else {
        start = this.searchForm.startYear
        end = this.searchForm.endYear
      }
      data = {
        start: start,
        end: end,
        TypeId:this.searchForm.TypeId,
        operatorId:this.searchForm.operatorId,
        groupbBy: this.conditions
      }
      this.init(url, data)
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    // list
    init(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            let data1=[];
            //清洗年月
            for(let i=0;i<res[0].value.length-1;i++){
              data1.push(res[0].value[i].year+"-"+res[0].value[i].month)
            }
            //清晰Key
            let data2=[];
            let data3=[];
            for(let i=0;i<res.length-1;i++){
              data2.push(res[i].key);
              let d1=[];
              for(let i1=0;i1<res[i].value.length-1;i1++){
                d1.push(res[i].value[i1].count);
              }
              let x={
                name:res[i].key,
                type: 'line',
                stack: '总量',
                data:d1
              }
              data3.push(x);
            }
            this.echarts(data1,data2,data3)
          })
    }
  },
  mounted() {
    //
    this.tabConditions()
  }
}
</script>

<style lang="scss" scoped>
.pecipeList {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }

  .decBox {
    padding-right: 20px;

    i {
      font-style: normal;
    }
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }

    .tagList {
      margin-right: 10px;
    }
  }
}
</style>